/* Vesari – Willow: turns Kaching's color dropdowns into image swatches.
   The original <select> stays in the page (hidden) so Kaching keeps working. */
(function () {
  var MAP = window.WK_SWATCHES || {};

  function enhance(select) {
    if (select.dataset.wkDone) return;
    select.dataset.wkDone = '1';
    var main = select.closest('.kaching-bundles__bar-variant-main') || select.parentNode;
    var holder = select.closest('.kaching-bundles__bar-variant');
    if (holder) holder.classList.add('wk-enhanced');

    var row = document.createElement('div');
    row.className = 'wk-row';
    var label = document.createElement('span');
    label.className = 'wk-row-label';
    var picked = document.createElement('span');
    picked.className = 'wk-picked';
    label.appendChild(picked);
    var wrap = document.createElement('div');
    wrap.className = 'wk-swatches';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Color');

    Array.prototype.forEach.call(select.options, function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wk-swatch';
      b.title = opt.value;
      b.setAttribute('aria-label', opt.value);
      b.dataset.value = opt.value;
      if (MAP[opt.value]) b.style.backgroundImage = 'url("' + MAP[opt.value] + '")';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      wrap.appendChild(b);
    });

    function sync() {
      Array.prototype.forEach.call(wrap.children, function (b) {
        b.setAttribute('aria-pressed', b.dataset.value === select.value ? 'true' : 'false');
      });
      picked.textContent = select.value;
    }
    select.addEventListener('change', sync);
    sync();

    row.appendChild(label);
    row.appendChild(wrap);
    main.appendChild(row);
  }

  function run() {
    document
      .querySelectorAll('.kaching-bundles select.kaching-bundles__bar-variant-select[data-name="Color"]')
      .forEach(enhance);
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  run();
})();
